<template>
    <div>
            <div class="bath-batch-title">Bath Batch Send Announcement & Email </div>
            <el-form label-width="120px" :model="formLabelAlign">
                    <el-form-item label="Template Type">
                        <el-radio-group v-model="formLabelAlign.templateType">
                            <el-radio :label="1">Status template</el-radio>
                            <el-radio :label="0">Other template</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Template">
                        <el-select v-model="formLabelAlign.templateId" placeholder="">
                            <el-option v-for="(item,index) in templates" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
            </el-form>
            <div class="checkbox-page">
                    <el-radio-group v-model="formLabelAlign.sendType">
                       <el-radio name="type" v-for="(item,index) in sendType" :key="index" :label="item.value">{{item.label}}</el-radio>
                    </el-radio-group>
                    <el-button  type="warning" @click="onSend">Send</el-button>
            </div>
            <loadingSlotDialog
                    @close="closeDelete"
                    :centerDialogVisible="centerDeleteDialogVisible"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="121.06396484375" height="91.02490234375" viewBox="0 0 121.06396484375 91.02490234375" fill="none">
                    <path d="M108.958 0L12.1064 0C5.4479 0 0.0605321 5.12015 0.0605321 11.3781L0 79.6468C0 85.9048 5.4479 91.0249 12.1064 91.0249L108.958 91.0249C115.617 91.0249 121.064 85.9048 121.064 79.6468L121.064 11.3781C121.064 5.12015 115.617 0 108.958 0ZM108.958 22.7562L60.5322 51.2015L12.1064 22.7562L12.1064 11.3781L60.5322 39.8234L108.958 11.3781L108.958 22.7562Z"   fill="#FF9D00" >
                    </path>
                    </svg>
                    <div class="dialog-text">Confirm to batch send the email?</div>
                    <el-button @click="onConfirm" type="info">Confirm</el-button>
                    <el-button @click="onCancel">Cancel</el-button>
           </loadingSlotDialog>
    </div>
</template>

<script>
    import loadingSlotDialog from "@/components/loadingSlotDialog";
    import {batchSendAnnouncementEmails} from '@/api/admin/application'
    import {getTemplates} from '@/api/admin/notification'
    export default {
        components: { loadingSlotDialog, },
        props:{
            applicationFormIds:{
                type:Array,
                default:function(){}
            },
            isSendTemplate:{
                type:Boolean,
                default:false
            },
            formType:{
                type:Number,
                default:0
            },
            type:{
                type:Number,
                default:0
            },
        },
        data() {
            return {
                centerDeleteDialogVisible:false,
                templates:[],
                checkList:[],
                formLabelAlign: {
                    applicationFormIds: null,
                    type: 0,
                    templateType: 0,
                    templateId: null,
                    sendType: 0
                }
            }
        },
        watch:{
            'formLabelAlign.templateType':{
                handler(v){
                    if(v!=null){
                        this.getTemplates()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        methods:{
            onCancel(){
                this.centerDeleteDialogVisible = false
                this.$emit('closeCenter')
            },
            onConfirm(){
                this.batchSendAnnouncementEmails()
            },
            closeDelete(v){
                this.centerDeleteDialogVisible = v
            },
            onSend(){
                if(this.isSendTemplate){
                    this.centerDeleteDialogVisible = true
                }else {
                    this.batchSendAnnouncementEmails()
                }
                
            },
            batchSendAnnouncementEmails(){
                let from = {
                    applicationFormIds: [
                        ...this.applicationFormIds
                    ],
                    type: this.type,
                    templateType: this.formLabelAlign.templateType,
                    templateId: this.formLabelAlign.templateId,
                    sendType: this.formLabelAlign.sendType
                }
                batchSendAnnouncementEmails(from).then(()=>{
                   this.$message.success('Set successfully.')
                   this.$emit('closeCenter')
                })
            },
            getTemplates(){
                let from ={
                    type:this.formLabelAlign.templateType,
                    formType:this.formType
                }
                getTemplates(from).then((v)=>{
                    this.templates = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.bath-batch-title{
    font-size: 28px;
    text-align: left;
}
.checkbox-page{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;
    margin-top: 30px;
}
.el-button--warning{
    margin-left: 30px;
}
.dialog-text{
    font-size: 30px;
    font-weight: bold;
}
.el-button--info{
    width: auto;
}
</style>